import React from 'react';
import styles from '../TripTrackingV2.module.scss';

const TotalDistanceCard = ({ distance }) => (
  <section className={styles.card}>
    <div className={styles.locationName}>{`Total Distance: ${parseInt(distance, 10) || 0} km`}</div>
  </section>
);

export default TotalDistanceCard;
